export default {"src":"/_next/static/media/BASIC_DISABLED.549c7ac6.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};